import { api } from "../../api"; // importa il tuo api centrale
import { TOP5_ENDPOINTS } from "../../../constants/endpoints";

export const top5Api = api.injectEndpoints({
  endpoints: (builder) => ({
    getTop5Videos: builder.query({
      query: () => ({
        url: TOP5_ENDPOINTS.GET_TOP5,
        method: "POST",
        // se serve, puoi passare headers, body, ecc.
        headers: { "Content-Type": "application/json" },
      }),
      providesTags: ["Top5Videos"], // opzionale, se usi i tags
    }),
  }),
  overrideExisting: false,
});

export const { useGetTop5VideosQuery } = top5Api;
